/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const PAGE_SIZE = 200;

export const listProductVendors = createAsyncThunk(
  'productVendors/list',
  async ({ search = '', from = 0 } = {}, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.productVendors.list({ search, from, size: PAGE_SIZE });
      return data || [];
    } catch (error) {
      Logger.error(new Error('Error product vendors fetching'), { error }, [
        'ListProductVendorsFailed',
        { errorMessage: 'Product vendors can not be fetched from backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(listProductVendors.pending, (state, { meta }) => {
      const { from = 0 } = meta.arg || {};
      if (from) {
        state.isPageLoading = true;
      } else {
        state.isLoading = true;
      }
      state.error = null;
    })
    .addCase(listProductVendors.fulfilled, (state, { payload, meta }) => {
      const { search = '', from = 0 } = meta.arg || {};
      if (from) {
        const existingIds = new Set(state.items.map((item) => item._id));
        state.items.push(...payload.filter((item) => !existingIds.has(item._id)));
        state.isPageLoading = false;
      } else {
        state.items = payload;
        state.searchQuery = search;
        state.isLoading = false;
        if (!search) {
          state.hasRegistryItems = payload.length > 0;
        }
      }
      state.hasMore = payload.length === PAGE_SIZE;
      state.isLoaded = true;
    })
    .addCase(listProductVendors.rejected, (state, { error, meta }) => {
      const { from = 0 } = meta.arg || {};
      if (from) {
        state.isPageLoading = false;
      } else {
        state.isLoading = false;
      }
      state.error = error;
    });
};
